import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { SelectionItem } from 'modules/common';

function Selection({
  options,
  labelClassName,
  label,
  name,
  required,
  isOptional,
  selectionItemProps,
  onChange,
  onSetFieldValue,
  value,
  isLoading,
  disabled,
  containerClassName,
}) {
  const selectProps = {
    name,
    value,
    disabled,
    onSetFieldValue,
    onChange,
    isLoading,
  };

  return (
    <div className="w-full relative">
      {label && (
        <label
          className={cn('ds-form-label flex items-center', labelClassName)}
          htmlFor={name}
        >
          <div className="flex-1">
            {label}{' '}
            {required ? (
              <span className="text-utility-danger-base">*</span>
            ) : (
              ''
            )}
          </div>

          {isOptional && <div className="font-normal">Optional</div>}
        </label>
      )}

      <div className={cn('flex flex-col gap-ds-8', containerClassName)}>
        {options?.map((item, key) => (
          <SelectionItem
            // eslint-disable-next-line react/no-array-index-key
            key={key}
            {...selectProps}
            {...selectionItemProps}
            {...item}
          />
        ))}
      </div>
    </div>
  );
}

export default Selection;

Selection.defaultProps = {
  options: [],
  labelClassName: '',
  label: '',
  name: '',
  required: false,
  isOptional: false,
  selectionItemProps: {},
  onChange: false,
  onSetFieldValue: false,
  value: false,
  isLoading: false,
  disabled: false,
  containerClassName: '',
};

Selection.propTypes = {
  // selection item props
  options: PropTypes.instanceOf(Array),
  name: PropTypes.string,
  selectionItemProps: PropTypes.instanceOf(Object),
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  containerClassName: PropTypes.string,
  required: PropTypes.bool,
  isOptional: PropTypes.bool,
  onChange: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Function),
  ]),
  onSetFieldValue: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.instanceOf(Function),
  ]),
  value: PropTypes.bool,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};
